export const PR_PT = "PR_PT";
export const PR_PPT = "PR_PPT";
export const FREQUENCY = "INPUT_MODE";
export const PREMIUM = "PR_ANNPREM";
export const ANNUITY_OPTION = "AnnuityOption"
export const FUNDSTRATEGY = "FUNDSTRATEGY"
export const FUNDSTRATEGY_ID = "FUNDSTRATEGYID"